﻿﻿export function extendFormElements(ICO){
   Object.assign(ICO,
   {
      uploadPhoto : function(image, i){
          //generate photo upload HTML  	  	
          var div = document.getElementById('ICO-create');
          var photoPost = document.createElement('div');
          photoPost.setAttribute('id','photo-'+ i +'-post');
          div.appendChild(photoPost);
          
          //div element for each image upload .ICO-image-upload-form      
          var f = document.createElement('div');
          f.setAttribute('name','photo-'+i+'-upload');
          f.setAttribute('id','photo-'+i+'-upload');
          f.setAttribute('class','ICO-image-upload-form');
          //f.setAttribute('action','');
          
          var imageLabel = image.label;
          
          //create file input .ICO-upload
          var buttonWrap = document.createElement('div');
          buttonWrap.setAttribute('class','ICO-upload-btn');
          f.appendChild(buttonWrap);
          var upButton = document.createElement('button');
          upButton.setAttribute('class','ICO-btn');
          upButton.setAttribute('id','ICO-img-'+ imageLabel);
          upButton.appendChild(document.createTextNode('Upload '+ imageLabel));
          buttonWrap.appendChild(upButton);
          
         var rButtonWrap = document.createElement('div');
         rButtonWrap.setAttribute('class','ICO-upload-btn ICO-rotate-image'+i);
         rButtonWrap.setAttribute('data-deg','-90');
         f.appendChild(rButtonWrap);
         var rotButton = document.createElement('button');
         rotButton.setAttribute('class','ICO-btn');
         rotButton.setAttribute('id','ICO-rot-'+ imageLabel);
         rotButton.appendChild(document.createTextNode('⭮'));
         rButtonWrap.appendChild(rotButton);
          
          var img = document.createElement('input');
          img.setAttribute('type','file');
          img.setAttribute('class','ICO-upload');
          //img.setAttribute('accept','img/jpeg');
          img.setAttribute('id','ICO-upload-'+  i );
          img.setAttribute('data-id', i);
             //make all miges required for testimg
             image.required = true
          if (image.required == true){
             img.required = true;
          }   
          
          buttonWrap.appendChild(img);
          f.appendChild(document.createElement('br'));
    
          f.appendChild(document.createElement('br'));
          var photoPre = document.createElement('div');
          photoPre.setAttribute('id','photo-'+  i  +'-pre');
          f.appendChild(photoPre);
          f.appendChild(document.createElement('br'));
          
          div.appendChild(f);
          
          //make the croppie happen
          var w = image.dimensions.width;
          var h = image.dimensions.height;
          var isUploaded = false;
          
            var uploadC;
                                                     
            
              function readFile(input, index) {
                 if (input.files && input.files[0]) {
                       var reader = new FileReader();
                       
                       reader.onload = function (e) {
                       var readyEl = document.querySelector('.upload-image-'+ i);
                       if (readyEl) readyEl.classList.add('ready');
                          uploadC.bind({
                             url: e.target.result
                          }).then(function(){
                             img.setAttribute('isUploaded', 'true');
                                ICO.makeJpeg(uploadC, i);
                          });
                          
                       }
                       
                       reader.readAsDataURL(input.files[0]);
                    
                   }
                   else {
                      swal("Sorry - you're browser doesn't support the FileReader API");
                  }
              }
        
              var uploadEl = document.getElementById('photo-'+ i +'-pre');
              uploadC = new Croppie(uploadEl, {
                 viewport: {
                    width: w * ICO.vars.ICOIPM,
                    height: h * ICO.vars.ICOIPM,
                    type: 'square'
                 },
                 enableExif: true,
                 enableOrientation:true,
                 enforceBoundary: false,
                 boundary: {
                     width: w * ICO.vars.ICOIPM + ICO.vars.ICOCA,
                     height: h * ICO.vars.ICOIPM + ICO.vars.ICOCA,
                 },
                 update: function () {
                    ICO.makeJpeg(this, i);
                 }
              });

            var rotEl = document.querySelector('.ICO-rotate-image'+i);
            if (rotEl) {
               rotEl.addEventListener('click', function(ev) {
                     uploadC.rotate(parseInt(this.dataset.deg));

                 });
            }

              document.getElementById('ICO-upload-'+ i).addEventListener('change', function () { readFile(this); });
              ICO.vars.uploadCrop.push({id :'photo-'+ i +'-pre', token : image.token, required : img.required, ind : i});

             
   },
        makeJpeg : function (cropped, i){
                        cropped.result({
                        type: 'rawcanvas',
                        size: 'viewport',
                        format: 'png'
                        }).then(function (response) {
                        ICO.vars.imageCrops[i] = response.toDataURL('image/png');
                        });
        },
      addSelectBox : function(select, i){
         var div = document.getElementById('ICO-create');

         // .ICO_text_input_div
         var selectDiv = document.createElement('div');
         selectDiv.setAttribute('class','ICO_select_input_div');
         selectDiv.setAttribute('id','ICO-select-input-' + i);
         div.appendChild(selectDiv);

         // .ICO_input_title
         var inputTitle = document.createElement('h3');
         inputTitle.setAttribute('class','ICO_input_title');
         inputTitle.setAttribute('id','ICO-input-title' + i);
         inputTitle.appendChild(document.createTextNode(select.label + ':'));
         selectDiv.appendChild(inputTitle);


         //.ICO_select_input
         var selectInput = document.createElement('select');
         selectInput.setAttribute('size','1');
         selectInput.setAttribute('name',select.token);
         selectInput.setAttribute('id', select.token);
         selectInput.setAttribute('class','ICO_select_input');
         if (select.required == true){
            selectInput.setAttribute('required', '');
         }      
         selectDiv.appendChild(selectInput);
         
         var SEL = {
           addOption : function(option, i) {              
            var newOption = document.createElement('option');
            newOption.setAttribute('value', option);
            selectInput.appendChild(newOption);
            newOption.appendChild(document.createTextNode(option));
            }
          }	
         
         var optionsLength = select.options.length;
     
         for (var i = 0; i < optionsLength; i++){
           //console.log('Option '+ i + ':' + select.options[i]);
            SEL.addOption(select.options[i], i);
            
         }
               
      },
      addCheckBox : function(check, i){
      var div = document.getElementById('ICO-create');
  
      // .ICO_check_input_div
      var checkDiv = document.createElement('div');
      checkDiv.setAttribute('class','ICO_chech_input_div');
      checkDiv.setAttribute('id','ICO-check-input-' + i);
      div.appendChild(checkDiv);

      // .ICO_input_title
      var inputTitle = document.createElement('h3');
      inputTitle.setAttribute('class','ICO_input_title');
      inputTitle.setAttribute('id','ICO-input-title' + i);
      
      inputTitle.appendChild(document.createTextNode(check.label));
      var br = document.createElement('br');
      
       checkDiv.appendChild(inputTitle);
       checkDiv.appendChild(br);

      // .ICO_check_input
      var checkInput = document.createElement('input')
      checkInput.setAttribute('type','checkbox');
      checkInput.setAttribute('id',check.token);
      checkInput.setAttribute('class','ICO_check_input');
      checkDiv.appendChild(checkInput);
      
     
  
   },
      addTextToForm : function(text, i){
      
         var div = document.getElementById('ICO-create');

         // .ICO_text_input_div
         var textDiv = document.createElement('div');
         textDiv.setAttribute('class','ICO_text_input_div');
         textDiv.setAttribute('id','ICO-text-input-' + i);
         div.appendChild(textDiv);
         
         // .ICO_input_title
         var inputTitle = document.createElement('h3');
         inputTitle.setAttribute('class','ICO_input_title');
         inputTitle.setAttribute('id','ICO-input-title' + i);
         inputTitle.appendChild(document.createTextNode(text.label + ':'));
         textDiv.appendChild(inputTitle);
         
         
         //.ICO_text_input
         var textInput = document.createElement('input');
         textInput.setAttribute('type','text');
         textInput.setAttribute('name',text.token);
         textInput.setAttribute('id', text.token);
         textInput.setAttribute('class','ICO_text_input');
         textInput.setAttribute('placeholder', text.label);
         if (text.required == true){
            textInput.required = true;
         }      
         textDiv.appendChild(textInput);  

         return textDiv;

      },


      //TO DO: update addTextToForm to use this
       addTextField: function(div, //div to place field
                        title, //title text for the heading, from ICO_variables
                        h, //heading type (eg 'h3')
                        id, //div id/name
                        pl, //form placeholder text
                        req, //boolean is required
                        headingLeft) //boolean for heading position: true for left, false for top
      {
         // .ICO_text_input_div
         var textDiv = ICO.flexDiv(id + '-ICO-text-input', headingLeft);
         div.appendChild(textDiv);
      
         // .ICO_input_title       
                
         if (headingLeft) {
            var inputTitle = ICO.RightFlexText(h, id, title); 
         } else {
            var inputTitle = document.createElement(h);
            inputTitle.setAttribute('id', 'ICO-input-title' + id);
            inputTitle.appendChild(document.createTextNode(title));
            inputTitle.setAttribute('class', 'ICO_input_title');
         }
         
         textDiv.appendChild(inputTitle);
      
         //.ICO_text_input
         textDiv.appendChild(ICO.basicInput(id, pl, req));
         
      },

      basicInput: function(id, pl, req){
         var textInput = document.createElement('input');
            textInput.setAttribute('type', 'text');
            textInput.setAttribute('name', id);
            textInput.setAttribute('id', id);
            textInput.setAttribute('class', 'ICO_text_input');
            textInput.setAttribute('placeholder', pl);
         if (req == true) {
               textInput.required = true;
         }
         return textInput;
      },

      RightFlexText: function(h, id, txt){
         var inputTitle = document.createElement(h);
            inputTitle.setAttribute('id', 'ICO-input-title' + id);
            inputTitle.appendChild(document.createTextNode(txt));
            inputTitle.setAttribute('class', 'ICO_input_left_title');
            inputTitle.style.marginRight = '10px'; // Add some space between the title and the input
            inputTitle.style.whiteSpace = 'nowrap'; // Prevent the title from wrapping
            inputTitle.style.textAlign = 'right'; // Align the title text to the right
            inputTitle.style.flexGrow = 1; // Allow the title to grow as needed to fill available space
            inputTitle.style.alignSelf = 'flex-start';
         return inputTitle;
      },

      flexDiv: function(id, flex){
         var textDiv = document.createElement('div');
         textDiv.setAttribute('class', 'ICO_text_input_div');
         textDiv.setAttribute('id', id);
         if (flex) {
               textDiv.style.display = 'flex'; // Use flexbox for horizontal alignment
               textDiv.style.alignItems = 'center'; // Align items vertically in the center, including the title
               textDiv.style.flexWrap = 'nowrap'; // Prevent wrapping of items
         }
         return textDiv;
      },

      addDateField: function(
                     div, //div to place field
                     title, //title text for the heading, from ICO_variables
                     h, //heading type (eg 'h3')
                     id, //div id/name
                     req, //boolean is required
                     headingLeft)
      {

      },

      adjustTitleBoxWidths: function() {
         // Find all title elements
         var titles = document.querySelectorAll('.ICO_input_left_title');
         var maxWidth = 0;
     
         // Determine the largest width
         titles.forEach(function(title) {
             var titleWidth = title.offsetWidth;
             if (titleWidth > maxWidth) {
                 maxWidth = titleWidth;
             }
         });
     
         // Apply the largest width to all title elements
         titles.forEach(function(title) {
             title.style.minWidth = maxWidth + 'px';
         });
     },

     addendumText: function (//returns <p> element to add additional properties.
                     div, //where to put the text
                     str, //text string from ICO_variables
                     loc) //location (left | right | center)                     
      {
         var addTxt = document.createElement('p');
            addTxt.style.textAlign = loc;
            addTxt.setAttribute('class','ICO-add-txt');
            addTxt.innerHTML=str;
         div.appendChild(addTxt);
         return addTxt;
      },

//QR code form element is in ICO_vcard.js to avoid needless loading.
      
      CheckRequired: function(inputField){
      
      	inputField.classList.remove('ICO_text_input_req');
                 
	      if (inputField.required == true && inputField.value == '') {
	      	//console.log(inputField+' is required');
	      	inputField.classList.toggle('ICO_text_input_req');
	         ICO.formComplete = false;
	      }
         
      },
      
      CheckImages : function(field, i){
         var imgID = 'ICO-upload-' + i;
         var img = document.getElementById(imgID);

         if(img.getAttribute('isuploaded') !== 'true' && img.required == 'true'){
            ICO.formComplete = false;				
         }
         
      },      
      
      inputObject : function(inputData, i){
         var subData = document.getElementById(inputData.token).value;

         var inObj = '{\"type\":\"'+inputData.type+'\",\"label\":\"'+inputData.label+'\",\"token\":\"'+inputData.token+'\",\"value\":\"'+subData+'\"}';
         
         ICO.cardData.push(inObj);
         
      },

	   inputImage : function(inputData, i){

	      var jpegURL = ICO.vars.imageCrops[i];

	      var inObj = '{\"type\":\"'+inputData.type+'\",\"label\":\"'+inputData.label+'\",\"token\":\"'+inputData.token+'\",\"value\":\"'+ jpegURL +'\"}';
	      
	      ICO.cardData.push(inObj);
	      

	   }, 
	   
           shippingForm : function(){

                ICO.shipFields = [];

             var sf = document.createElement('form');
             sf.name = 'ICO-shipping-form';
             sf.id = 'ICO-shipping-form';
             sf.action = '';
             sf.setAttribute('accept-charset','UTF-8');
             sf.method = '';

             ICO.createLabeledInput(sf, ICO.vars.copies+' ', 'ICO-copies', {
                type: 'number',
                inputClass: 'ICO_number_input',
                name: 'ICO-quantity',
                required: true,
                min: ICO.params.minCopies,
                max: ICO.params.maxCopies,
                value: ICO.params.defaultCopies,
                labelClass: 'ICO_input_title',
                hide: ICO.params.changeQuantity === false
             });
             ICO.shipFields.push('ICO-copies');

             var st = document.createElement('h2');
             st.setAttribute('class','ICO_form_title ICO-center');
        if (ICO.settings.fixed_address === false){
                st.appendChild(document.createTextNode(ICO.vars.shippingForm));
        }else st.appendChild(document.createTextNode(ICO.vars.fixedAddress));
             sf.appendChild(st);

             ICO.createLabeledInput(sf, 'Name', 'ICO-ship-name', {
                placeholder: ICO.vars.namePlaceholder,
                required: true,
                autocomplete: 'name'
             });
             ICO.shipFields.push('ICO-ship-name');

             if (ICO.settings.fixed_address === false){
                ICO.createAddressBlock(sf, 'ship', ICO.shipFields, 'shipping');
             }

             ICO.createEmailConfirmation(sf, 'ICO-ship-email', ICO.vars.address1Placeholder, ICO.shipFields);

               document.getElementById('ICO-shipping').appendChild(sf);

               var sa = document.createElement('div');
               sa.setAttribute('id', 'ICO-ship-alerts');
               document.getElementById('ICO-shipping').appendChild(sa);


               if(ICO.params.payOnCheckout == true){
                               ICO.appendButtons('ICO-preview','ICO-shipping',ICO.vars.paymentBc,'ICO.checkShipForm()');
               }else{
           ICO.appendButtons('ICO-preview','ICO-shipping',ICO.vars.noPayButtonText,'ICO.checkShipForm()');
               }


          if (ICO.settings.fixed_address === false){
            ICO.generateCountries(ICO.vars.shippingDom, 'ICO-ship-country');
            if (ICO.params.intShip == true){
               ICO.generateCountries(ICO.vars.shippingInt, 'ICO-ship-country');
            }
         }


           },

      createLabeledInput : function(parent, labelText, id, opts){
         var o = opts || {};
         var heading = o.heading || 'h3';
         var label = document.createElement(heading);
            label.setAttribute('class', o.labelClass || 'ICO_ship_form_title');
            label.id = id + '-label';
            label.appendChild(document.createTextNode(labelText));
            if (o.hide === true) { label.style.display = 'none'; }
            parent.appendChild(label);

         var input = document.createElement('input');
            input.type = o.type || 'text';
            input.id = id;
            if (o.name) input.name = o.name;
            input.setAttribute('class', o.inputClass || 'ICO_ship_text_input');
            if (o.placeholder) input.placeholder = o.placeholder;
            if (o.required === true) input.required = true;
            if (o.autocomplete) input.autocomplete = o.autocomplete;
            if (o.min !== undefined) input.min = o.min;
            if (o.max !== undefined) input.max = o.max;
            if (o.value !== undefined) input.value = o.value;
         parent.appendChild(input);
         return input;
      },

      createAddressBlock : function(parent, prefix, fields, autoPrefix){
         var pfx = 'ICO-' + prefix + '-';
         ICO.createLabeledInput(parent, 'Address 1', pfx+'address1', {
            placeholder: ICO.vars.address1Placeholder,
            required: true,
            autocomplete: autoPrefix ? autoPrefix + ' street-address' : undefined
         });
         fields.push(pfx+'address1');

         ICO.createLabeledInput(parent, 'Address 2', pfx+'address2', {
            placeholder: ICO.vars.address1Placeholder,
            autocomplete: autoPrefix ? autoPrefix + ' address-line2' : undefined
         });
         fields.push(pfx+'address2');

         var adTbl = document.createElement('table');
            adTbl.setAttribute('class', 'ICO-' + prefix + '-table');
            adTbl.style.width = '100%';
         var row = document.createElement('tr');
            adTbl.appendChild(row);
         var cityCell = document.createElement('td');
            row.appendChild(cityCell);
         var stateCell = document.createElement('td');
            row.appendChild(stateCell);
         var zipCell = document.createElement('td');
            row.appendChild(zipCell);

         ICO.createLabeledInput(cityCell, 'City', pfx+'city', {
            placeholder: ICO.vars.cityPlaceholder,
            required: true,
            autocomplete: autoPrefix ? autoPrefix + ' locality' : undefined
         });
         fields.push(pfx+'city');

         ICO.createLabeledInput(stateCell, 'State/Province', pfx+'state', {
            required: true,
            autocomplete: autoPrefix ? autoPrefix + ' region' : undefined
         });
         fields.push(pfx+'state');

         ICO.createLabeledInput(zipCell, 'ZIP', pfx+'zip', {
            placeholder: ICO.vars.zipPlaceholder,
            required: true,
            autocomplete: autoPrefix ? autoPrefix + ' postal-code' : undefined
         });
         fields.push(pfx+'zip');

         parent.appendChild(adTbl);

         var countryLabel = document.createElement('h3');
            countryLabel.setAttribute('class','ICO_ship_form_title');
            countryLabel.id = pfx + 'country-label';
            countryLabel.appendChild(document.createTextNode('Country'));
            parent.appendChild(countryLabel);
         var country = document.createElement('select');
            country.name = pfx + 'country';
            country.id = pfx + 'country';
            country.setAttribute('class','ICO_ship_text_input');
            country.required = true;
            parent.appendChild(country);
         fields.push(pfx+'country');
      },

      createEmailConfirmation : function(parent, baseId, placeholder, fields){
         ICO.createLabeledInput(parent, 'Email', baseId + '1', {
            placeholder: placeholder,
            required: true,
            autocomplete: 'email'
         });
         fields.push(baseId + '1');

         ICO.createLabeledInput(parent, 'Confirm Email', baseId + '2', {
            placeholder: placeholder,
            required: true,
            autocomplete: 'email'
         });
         fields.push(baseId + '2');
      },

      createCardBlock : function(){
         var div = document.createElement('div');

         var ccl = document.createElement('h3');
            ccl.setAttribute('class','ICO_ship_form_title');
            ccl.id = 'ICO-cc-number-label';
            ccl.appendChild(document.createTextNode(ICO.vars.cCN));
            div.appendChild(ccl);
         var cc = document.createElement('input');
            cc.type = 'text';
            cc.id = 'ICO-cc-number';
            cc.autocomplete='cc-number';
            cc.name='cardnumber';
            cc.setAttribute('class','ICO_ship_text_input');
            cc.placeholder = ICO.vars.namePlaceholder;
            cc.required = true;
            div.appendChild(cc);

         var cctbl = document.createElement('table');
            cctbl.setAttribute('class', 'ICO-ship-table');

         var tr1 = document.createElement('tr');
            cctbl.appendChild(tr1);

         var td11 = document.createElement('td');
            tr1.appendChild(td11);
         var xml = document.createElement('h3');
            xml.setAttribute('class','ICO_ship_form_title');
            xml.id = 'ICO-cc-month-label';
            xml.appendChild(document.createTextNode('Exp. Month'));
            td11.appendChild(xml);

         var td12 = document.createElement('td');
            tr1.appendChild(td12);
         var xyl = document.createElement('h3');
            xyl.setAttribute('class','ICO_ship_form_title');
            xyl.id = 'ICO-cc-year-label';
            xyl.appendChild(document.createTextNode('Exp. Year'));
            td12.appendChild(xyl);

         var td13 = document.createElement('td');
            tr1.appendChild(td13);
         var cvcl = document.createElement('h3');
            cvcl.setAttribute('class','ICO_ship_form_title');
            cvcl.id = 'ICO-cc-cvc-label';
            cvcl.appendChild(document.createTextNode('CVC'));
            td13.appendChild(cvcl);

         var tr2 = document.createElement('tr');
            tr2.setAttribute('class','ICO_text_input_div');
            cctbl.appendChild(tr2);

         var td21 = document.createElement('td');
            tr2.appendChild(td21);
         var xm = document.createElement('select');
            xm.name = 'ICO-cc-month';
            xm.setAttribute('id','ICO-cc-month');
            xm.setAttribute('class','ICO_select_input');
            xm.autocomplete='cc-month';
            xm.required = true;
            xm.style.width='100%';
            td21.appendChild(xm);

         var td22 = document.createElement('td');
            tr2.appendChild(td22);
         var xy = document.createElement('select');
            xy.name = 'ICO-cc-year';
            xy.setAttribute('id','ICO-cc-year');
            xy.setAttribute('class','ICO_select_input');
            xy.required = true;
            xy.autocomplete='cc-year';
            xy.style.width='100%';
            td22.appendChild(xy);

         var td23 = document.createElement('td');
            tr2.appendChild(td23);
         var cvc = document.createElement('input');
            cvc.type = 'text';
            cvc.id = 'ICO-cc-cvc';
            cvc.setAttribute('class','ICO_ship_text_input');
            cvc.required = true;
            cvc.placeholder = ICO.vars.zipPlaceholder;
            cvc.autocomplete='cc-csc';
            cvc.minlength = '3';
            cvc.maxlength = '3';
            cvc.size = '4';
            td23.appendChild(cvc);

         div.appendChild(cctbl);
         return div;
      },

      appendButtons : function(back, div, txt, fcn){
         ICO.makeButtons(back, div, txt, fcn);
      },

      generateCountries : function(list, id){
           
         var listLength = list.length;
         for (var i=0; i < listLength; i++){
            var st = document.createElement('option');
            st.value = list[i].ccode;
            st.appendChild(document.createTextNode(list[i].cname));
            document.getElementById(id).appendChild(st);
         }         
      },	   
      
      shipVars : function(){
         ICO.vars.quantity = document.getElementById('ICO-copies').value;
        ////console.log(ICO.vars.quantity);
         if (ICO.settings.fixed_address === false){            
            ICO.vars.sAddress1 = document.getElementById('ICO-ship-address1').value;         
            ICO.vars.sAddress2 = document.getElementById('ICO-ship-address2').value;         
            ICO.vars.sCity = document.getElementById('ICO-ship-city').value;
            ICO.vars.sState = document.getElementById('ICO-ship-state').value;
            ICO.vars.sZip = document.getElementById('ICO-ship-zip').value;
            ICO.vars.sCountry = document.getElementById('ICO-ship-country').value;
         }
         ICO.vars.sName = document.getElementById('ICO-ship-name').value;
         ICO.vars.email = document.getElementById('ICO-ship-email1').value;
         
         if (ICO.vars.quantity == 1 ){
         	ICO.vars.cardOrCards = 'card';
         } else ICO.vars.cardOrCards = 'cards';
         
      },
      
                paymentForm : function(){

                        ICO.billFields = [];

                        var div = document.getElementById('ICO-payment-form') ;
			
	      var totDiv = document.getElementById('ICO-payment-total') ; 
	     	      
	      var total = document.createElement('h3');
	      total.id = 'ICO-total-cost';
	      total.setAttribute('class', 'ICO-center ICO-msg');		
	      totDiv.appendChild(total);	
			
		   var pf = document.createElement('form');
         pf.name = 'ICO-payment-form';
         pf.id = 'ICO-payment-form';
         pf.action = '';
         pf.setAttribute('accept-charset','UTF-8');
         pf.method = '';
         div.appendChild(pf);
         
         var pt = document.createElement('h2');
         pt.setAttribute('class','ICO_form_title ICO-center');
         pt.style.margin = '15px';
         pt.appendChild(document.createTextNode(ICO.vars.paymentForm));
         pf.appendChild(pt);
         
         var sAd;
         if (ICO.settings.fixed_address === false){
            var adLab = document.createElement('label');
            adLab.setAttribute('class','ICO-dim-mo');
            sAd = document.createElement('input');
            sAd.type = 'checkbox';
            sAd.name = 'ICO-bill-address-tog';
            sAd.id = 'ICO-bill-address-toggle';
            sAd.checked = true;
            adLab.appendChild(sAd);
            adLab.appendChild(document.createTextNode(ICO.vars.addressIsSame));
            pf.appendChild(adLab);
         }

         var pAdForm = document.createElement('div');
            pAdForm.name = 'ICO-pay-address';
            pAdForm.id = 'ICO-pay-address';
            if (ICO.settings.fixed_address === false){
               pAdForm.style.display = 'none';
            }

         ICO.createLabeledInput(pAdForm, 'Name', 'ICO-bill-name', {
            placeholder: ICO.vars.namePlaceholder,
            required: true,
            autocomplete: 'name'
         });
         ICO.billFields.push('ICO-bill-name');

         ICO.createAddressBlock(pAdForm, 'bill', ICO.billFields, 'billing');
         pf.appendChild(pAdForm);

         ICO.generateCountries(ICO.vars.shippingDom, 'ICO-bill-country');
         ICO.generateCountries(ICO.vars.shippingInt, 'ICO-bill-country');

         var cardBlock = ICO.createCardBlock();
         div.appendChild(cardBlock);
         ICO.generateMonths('ICO-cc-month');
         ICO.generateYears('ICO-cc-year');

         ICO.appendButtons('ICO-shipping', 'ICO-payment', ICO.vars.completePaymentBtn, 'ICO.completePayment()');
         if (ICO.settings.fixed_address === false){
            sAd.addEventListener('click', function(){
               if(sAd.checked == false){
                  pAdForm.style.display = 'block'
               }else pAdForm.style.display = 'none';
            });
         }


                },
		
		generateMonths : function(id){
		   var st = document.createElement('option');
         st.value = '';
         st.appendChild(document.createTextNode(ICO.vars.monthSel));
         var div = document.getElementById(id);
         div.appendChild(st);
      
         var l = ICO.vars.months.length;
         for (var i=0; i < l; i++){
            var st = document.createElement('option');
            st.value = i+1;
            st.appendChild(document.createTextNode('(' +('0'+(i+1)).slice(-2) + ') ' + ICO.vars.months[i]));
            div.appendChild(st);
         }
		},
		
		generateYears : function(id){
			 var div = document.getElementById(id);
			 var yr = new Date().getFullYear();
			 //console.log(yr);
			 
         for (var i=0; i < 50; i++){
            var st = document.createElement('option');
            st.value = yr+i;
            st.appendChild(document.createTextNode(yr+i+''));
            div.appendChild(st);
         }
      },	
      
      addToggleBar : function(
                     id, //where to put the bar
                     txt, //string on the bar from vars
                     exp, //true if expanded by default, false if not
                     ){
         let toggle = document.createElement('div');
         toggle.setAttribute('id', id+"-toggle");
         toggle.setAttribute('class', 'ICO-open-close-toggle');
         if(exp === true){
            id.isOpen=true;
            id.classList.add('ICO-open-options');
         }else if(exp === false){
            id.isOpen=false;
            id.classList.add('ICO-closed-options');
         }else toggle.setAttribute('class', 'ICO-open-close-toggle ICO-open-options');
         toggle.onclick = function(){ICO.toggleToggle(id);}

         id.appendChild(toggle);

         let togText = document.createElement("div");
         togText.setAttribute('class', 'ICO-toggle-text-box');
         togText.innerHTML+= txt;
         toggle.appendChild(togText);

         let togInd = document.createElement("div");
         togInd.setAttribute("class", "ICO-toggle-indicator");
         if (exp===true){
            togInd.innerHTML=ICO.vars.toggClose;
         }else togInd.innerHTML=ICO.vars.toggOpen;
         toggle.appendChild(togInd);         
         toggle.onclick = function(){ICO.toggleToggle(id, togInd);}

      },

      toggleToggle : function(el, ind){
         el.classList.toggle('ICO-open-options');
         el.classList.toggle('ICO-closed-options');
         if (el.isOpen===true){
            ind.innerHTML = ICO.vars.toggOpen;
            el.isOpen=false;
         } else{
            ind.innerHTML = ICO.vars.toggClose;
            el.isOpen=true;
         }

      },
		

		
   }, ICO);
}
